import { isNumber } from "~/tools/is-number";

export function px(value: number | string): string;
export function px(value: undefined | null | number | string): undefined | string;
export function px(value: undefined | null | number | string): undefined | string {
	if (isNumber(value)) {
		return `${value}px`;
	}

	if (value) {
		return value;
	}

	return undefined;
}
